var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"full-height":"","wrap":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('AppHeader')],1),_c('v-flex',{ref:"pageContent",attrs:{"xs12":"","id":"page-content"}},[_c('router-view')],1),_c('v-flex',{attrs:{"xs12":""}},[_c('AppFooter')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }